module.exports = __webpack_public_path__ + "../resources/img/ic_edit_button_lt.90d23c74.svg";